'use client'

import { useEffect } from 'react'

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    console.error(error)

    fetch('/api/logger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'nextjs_error_boundary',
        digest: error.digest,
        message: error.message,
        path: window.location.pathname,
        ts: new Date().toISOString(),
      }),
    }).catch(() => {})
  }, [error])

  return (
    <div className="@container">
      <div className="flex w-full flex-col items-center justify-center gap-3 px-5 py-10 text-center @tablet:px-8 @tablet:py-12 @laptop:px-11 @laptop:py-15">
        <h1 className="heading-hero-regular">Something went wrong.</h1>
        <p className="support-styles-intro-text-regular">
          Oops, looks like something went wrong.
        </p>
      </div>
    </div>
  )
}
